import React from "react";
import { b, l1, l2, ramka, krug, zero } from "../../util/icon";

export const DateBLock = (toDate, fromDate) => {
  // Получаем текущую дату в формате DD/MM/YYYY
  const today = new Date();
  const currentDate = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
  
  // Проверяем, совпадает ли toDate с текущей датой
  const isToday = toDate === currentDate;
  
  return (
    <div className="flex flex-row w-[16.41%] min-w-[200px]">
      <div className="flex-1 h-[100%] content-center font-rubik text-lg text-[#7D7D7D] font-light p-4">
        {fromDate}
      </div>

      <div className="h-[24px] w-[2px] bg-[#dbdbdb] my-auto "></div>

      <div
        className={
          isToday
            ? "flex-1 h-[100%] content-center  font-rubik  font-light text-xl text-[#FF6D00] rounded-l-[8px] "
            : "flex-1 h-[100%] content-center  font-rubik  font-light text-xl text-[#7D7D7D] rounded-l-[8px]"
        }
      >
        {toDate}
      </div>
    </div>
  );
};

const SewingImages = ({ sewing }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  
  if (!sewing) return null;
  
  const workers = Array.isArray(sewing) ? sewing : [sewing];
  if (workers.length === 0) return null;

  const hasMore = workers.length > 1;
  const displayWorkers = isExpanded ? workers : [workers[0]];

  return (
    <div 
      className="flex items-center cursor-pointer"
      onClick={() => hasMore && setIsExpanded(!isExpanded)}
    >
      {isExpanded ? (
        <div 
          className="flex items-center border-solid border-[1.5px] border-[#739D00]"
          style={{ borderRadius: "9999px", padding: "2px 6px" }}
        >
          {displayWorkers.map((worker, idx) => {
            const image = `${process.env.PUBLIC_URL}/assets/${encodeURIComponent(worker.trim())}.png`;
            return (
              <img
                key={idx}
                src={image}
                style={{
                  height: "40px",
                  width: "40px",
                  objectFit: "contain",
                  marginLeft: idx > 0 ? "-16px" : "0",
                }}
                title={worker}
                alt={worker}
              />
            );
          })}
        </div>
      ) : (
        hasMore ? ramka(workers[0]) : krug(workers[0])
      )}
    </div>
  );
};

export const MembersBlock = (manager, designer, sewing) => {
  return (
    <div className="flex w-[280px] bg-[#F9F9F9] justify-center">
      <div className="flex flex-1 items-center px-[24px] ">
        <div className="place-items-start">{renderImage(manager)}</div>
        <div className="place-items-center">{renderImage(designer)}</div>
        <div className="place-items-end"><SewingImages sewing={sewing} /></div>
      </div>
    </div>
  );
};

export const renderImage = (nameIMG) => {
  if (!nameIMG) return null;

  try {
    const safeName = encodeURIComponent(nameIMG.trim());
    const image = `${process.env.PUBLIC_URL}/assets/${safeName}.png`;

    return (
      <div>
        <img
          src={image}
          style={{
            height: "48px",
            width: "70px",
            margin: "auto",
            objectFit: "contain",
          }}
          title={nameIMG}
          alt={nameIMG}
        />
      </div>
    );
  } catch {
    return null;
  }
};

export const Button = (image, onClick) => {
  return (
    <div className="w-[10.10%] min-w-[120px] content-center">
      <button
        className="flex justify-center items-center w-[99%] h-[90%] bg-[#e6e6e6] rounded-r-[8px] font-medium text-[1vw] text-white hover:bg-[#739D00]"
        onClick={onClick}
      >
        {image}
      </button>
    </div>
  );
};

export const imgStudio = (studio) => {
  if (studio.studio) return renderImage("studio");
  if (studio.rip) return renderImage("rip");
  if (studio.print) return renderImage("print");
  if (studio.sewing) return renderImage("sewing");
  if (studio.inWork) return renderImage("inWork");
  if (studio.ready) return renderImage("ready");
  return null
}

export const renderStatusImage = (nameIMG) => {
  try {
    const image = `${process.env.PUBLIC_URL}/assets/${nameIMG}.png` || "";
    if (image != null) {
      return (
        <div className="h-[100%]  content-center">
          <img
            src={image}
            style={{ height: "90%", width: "90%", margin: "auto" }}
            alt={nameIMG}
            title={nameIMG}
          />
        </div>
      );
    }
  } catch {
    return <div className="h-[100%] w-[20%] content-center">{nameIMG}</div>;
  }
};

export const sortDate = (status, object) => {
  return status.sort((a, b) => {
    const [dayA, monthA, yearA] = a[object].split("/");
    const [dayB, monthB, yearB] = b[object].split("/");
    return yearB - yearA || monthB - monthA || dayB - dayA;
  });
};

export const search = (status, textSearch) => {
  if (!textSearch) return status;

  return status.filter(
    (i) =>
      i.toDate?.includes(textSearch) ||
      false ||
      i.fromDate?.includes(textSearch) ||
      false ||
      i.manager?.toLowerCase().includes(textSearch.toLowerCase()) ||
      false ||
      i.designer?.toLowerCase().includes(textSearch.toLowerCase()) ||
      false ||
      i.order?.toLowerCase().includes(textSearch.toLowerCase()) ||
      false ||
      i.client?.[0]?.toLowerCase().includes(textSearch.toLowerCase()) ||
      false
  );
};

export const searchPrint = (status, textSearch) => {
  if (!textSearch) return status;

  return status.map((folder) => ({
    ...folder,
    item:
      folder.item?.filter(
        (i) =>
          i.toDate?.includes(textSearch) ||
          false ||
          i.date?.includes(textSearch) ||
          false ||
          i.manager?.toLowerCase().includes(textSearch.toLowerCase()) ||
          false ||
          i.designer?.toLowerCase().includes(textSearch.toLowerCase()) ||
          false ||
          i.fileName?.toLowerCase().includes(textSearch.toLowerCase()) ||
          false
      ) || [],
  }));
};

export const place = (line) => {
  switch (line) {
    case "LINE 1":
    case "L1":
      return l1;
    case "LINE 2":
    case "L2":
      return l2;
    case "B":
      return b;
    default:
      return zero;
  }
};
